module.exports = __webpack_public_path__ + "static/fonts/Robotolightitalic.90c562a.woff2";